<template>
    <div class="row company" :class="{'company-simple': simple}" @click="openCompany(company)">
        <div class="top">
            <div class="left">
                <div class="logo">
                    <CompanyLogo 
                        :domain="company.domain ? company.domain : null"
                        :company_name="company.name ? company.name : company.domain ? company.domain : null"
                    />
                    <LabelMini :label="(company.label || company.label === 0) ? company.label : -1" />
                    <ThermometerMini v-if="!!company.leadscore" :leadscore="company.leadscore" />
                </div>
            </div>

            <div class="right">
                <div class="right-top">
                    <div class="right-top-left">
                        <div class="name">{{ company.name }}</div>
                        <div v-if="company.city" class="location">{{ company.city }}{{ company.city && company.country_code ? ', ' : '' }}<span>{{ company.country_code }}</span></div>
                    </div>
                    <div v-if="company.contacts && company.contacts.length > 0" class="right-top-right">
                        <ContactsMini :contacts="company.contacts" :numberOfContacts="company.total_contacts" />
                    </div>
                </div>
                <div class="right-bottom" v-if="(company.audiences && company.audiences.length > 0) || (company.tags && company.tags.length > 0)">
                    <AudiencesMini v-if="company.audiences && company.audiences.length > 0" :audiences="company.audiences" />
                    <TagsMini v-if="company.tags && company.tags.length > 0" :tags="company.tags" />
                </div>
            </div>
        </div>

        <div class="bottom" v-if="!simple && (company.changed_time || company.owner || company.last_visit || company.total_visits)">
            <ul class="specs-type-1">
                <li v-if="company.changed_time">
                    <div class="title">{{$t('components.prospects_list_item.last_change')}}</div>
                    <div class="content">{{ epochToDisplayDate(company.changed_time) }}</div>
                </li>

                <li v-if="company.owner">
                    <div class="title">{{$t('components.prospects_list_item.owner')}}</div>
                    <div class="content">{{ company.owner }}</div>
                </li>

                <li :class="!!company.last_visit ? '' : 'no-data'">
                    <div class="title">{{$t('components.prospects_list_item.last_visit')}}</div>
                    <div class="content">{{ !!company.last_visit ? epochToDisplayDate(company.last_visit) : '-' }}</div>
                </li>
                
                <li :class="!!company.total_visits ? '' : 'no-data'">
                    <div class="title">{{$t('components.prospects_list_item.number_of_visits')}}</div>
                    <div class="content">{{ company.total_visits || '0' }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'pinia';
import { useCompaniesStore } from '@/stores/companies';
import CompanyLogo from '@/components/elements/misc/CompanyLogo';
import ContactsMini from '@/components/elements/prospects/ContactsMini';
import LabelMini from '@/components/elements/misc/LabelMini';
import TagsMini from '@/components/elements/prospects/TagsMini';
import AudiencesMini from '@/components/elements/prospects/AudiencesMini';
import ThermometerMini from '@/components/elements/misc/ThermometerMini';
import { epochToDisplayDate } from '@/utils/dates';

export default {
    name: 'CompaniesListItem',
    components: {
        CompanyLogo,
        ContactsMini,
        LabelMini,
        TagsMini,
        AudiencesMini,
        ThermometerMini
    },
    props: {
        company: {
            type: Object,
            required: true
        },
        simple: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        epochToDisplayDate,
        ...mapActions(useCompaniesStore, ['openCompany']),
    }
}
</script>